import axios from 'axios';
import { getData, storeData } from './storage';
import { logOut } from './account';
import baseURL from '../config/baseURL';
import './http';

export const refreshAuthToken = async (refreshToken: string) => {
  const currentDateTime = new Date().toISOString();
  const data = {
    refresh: refreshToken,
  };

  try {
    const endpoint = `${baseURL}/auth/jwt/refresh/`;
    const response = await axios.post(endpoint, data);
    await storeData('access_token', response?.data?.access);
    await storeData('access_token_storage_time', currentDateTime);
    return { success: true, data: response?.data?.access };
  } catch (error) {
    console.error('An error occurred while refreshing the token.', error);
    return { success: false, data: error };
  }
};

export const getAuthToken = async () => {
  const currentDateTimeInMs = new Date().getTime();
  try {
    const storedAccessToken = await getData('access_token');
    const storedRefreshToken = await getData('refresh_token');
    const storedAccessTokenLogInTime = await getData('access_token_storage_time');
    const storedRefreshTokenLogInTime = await getData(
      'refresh_token_storage_time',
    );

    if (
      typeof storedRefreshTokenLogInTime === 'string' &&
      typeof storedAccessTokenLogInTime === 'string'
    ) {
      const storedRefreshDateTimeInMs = new Date(
        storedRefreshTokenLogInTime,
      ).getTime();
      const storedAccessDateTimeInMs = new Date(
        storedAccessTokenLogInTime,
      ).getTime();

      if (
        currentDateTimeInMs - storedAccessDateTimeInMs >
        0.3 * 60 * 1000
      ) {
        if (
          currentDateTimeInMs - storedRefreshDateTimeInMs >
          60 * 24 * 30 * 60 * 1000
        ) {
          const response = await logOut();
          return { success: false, data: response.data };
        }

        if (typeof storedRefreshToken === 'string') {
          try {
            const response = await refreshAuthToken(storedRefreshToken);
            return response.success
              ? { success: true, data: response.data }
              : { success: false, data: response.data };
          } catch (error) {
            console.error('An error occurred while refreshing the token');
            return { success: false, data: error };
          }
        }
      }

      if (typeof storedAccessToken === 'string') {
        return { success: true, data: storedAccessToken };
      }
    }
    return { success: false, data: undefined };
  } catch (error) {
    console.error('Unexpected error occurred while fetching the auth token:', error);
    return { success: false, data: undefined };
  }
};
